import React from 'react'

function Test (props) {
  return <div />;
}

export default Test



// WEBPACK FOOTER //
// ./app/javascript/components/Test.js